module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/martech_others_bg-34351aada2a773cc6c60cfc3ac978cc8.png";